/**
 * Pure helpers for Song Processing bulk archive selection scope.
 * Keeps query-wide Archive on allMatching (never a silent eligible-ids subset).
 */

export function isQueryWideJobSelection(args: {
  selectAllMatching: boolean;
  matchingTotal: number | null | undefined;
  selectedCount: number;
}): boolean {
  const { selectAllMatching, matchingTotal, selectedCount } = args;
  if (selectAllMatching) return true;
  return (
    matchingTotal != null &&
    matchingTotal > 0 &&
    selectedCount >= matchingTotal
  );
}

export function archiveBulkOpSelection(args: {
  selectAllMatching: boolean;
  matchingTotal: number | null | undefined;
  selectedJobIds: string[];
}): { selectionMode: "allMatching" | "ids"; ids?: string[] } {
  const queryWide = isQueryWideJobSelection({
    selectAllMatching: args.selectAllMatching,
    matchingTotal: args.matchingTotal,
    selectedCount: args.selectedJobIds.length,
  });
  if (queryWide) {
    return { selectionMode: "allMatching" };
  }
  // Full selected scope — including governed/ineligible rows — so the server
  // can skip with belongs-to-active-song instead of silent omission.
  return { selectionMode: "ids", ids: [...args.selectedJobIds] };
}
